module.exports = __webpack_public_path__ + "static/media/background2.b5e16234.png";